var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhiteBorderCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "111px",
    height: "111px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(244, 242, 246)",
    d: "M55.424,111.1 C25.69,111.1 0.373,86.305 0.373,55.950 C0.373,25.596 25.69,0.901 55.424,0.901 C85.778,0.901 110.473,25.596 110.473,55.950 C110.473,86.305 85.778,111.1 55.424,111.1 ZM55.424,11.118 C30.703,11.118 10.591,31.230 10.591,55.950 C10.591,80.671 30.703,100.783 55.424,100.783 C80.144,100.783 100.256,80.671 100.256,55.950 C100.256,31.230 80.144,11.118 55.424,11.118 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteBorderCircle);
export default __webpack_public_path__ + "static/media/white-border-circle.46131707e2c44385bdfb9892150ba97a.svg";
export { ForwardRef as ReactComponent };